import { Menu, MenuItem } from '@mui/material';

import { Space } from '../../mainApi';
import { SpacesService } from '../../services/spaces.service';

type SpaceMenuProps = {
  anchorEl: HTMLElement | null;
  space: Space | null;
  onClose: () => void;
  onEdit: () => void;
  onSetThumbnail: () => void;
  onCopy: () => void;
  onArchiveRestore: () => void;
  onDelete: () => void;
};

export const SpaceMenu = ({
  anchorEl,
  space,
  onClose,
  onEdit,
  onSetThumbnail,
  onCopy,
  onArchiveRestore,
  onDelete,
}: SpaceMenuProps) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl && space)}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          borderRadius: '3px',
          boxShadow: '0 1px 4px #cccccc',
          minWidth: 190,
        },
      },
    }}
  >
    <MenuItem onClick={onEdit} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
      Edit
    </MenuItem>
    {space && SpacesService.canSetThumbnail(space) ? (
      <MenuItem onClick={onSetThumbnail} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
        Set Thumbnail
      </MenuItem>
    ) : null}
    {space?.type !== 'game' ? (
      <MenuItem onClick={onCopy} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
        Copy
      </MenuItem>
    ) : null}
    <MenuItem onClick={onArchiveRestore} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
      {space?.archived ? 'Restore' : 'Archive'}
    </MenuItem>
    <MenuItem onClick={onDelete} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
      Delete
    </MenuItem>
  </Menu>
);
